import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BulkCreateService } from './bulk-create.service';
import { CommonBillingService } from 'src/app/billing/shared/common-billing.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { HttpEventType } from '@angular/common/http';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bulk-create',
  templateUrl: './bulk-create.component.html',
  styleUrls: ['./bulk-create.component.scss']
})
export class BulkCreateComponent implements OnInit {

  public isLoading = false;
  public showFileUploadModal = false;
  public showUploadModal = false;
  public fileToUpload: any;
  public uploadFileError: any;
  public fileName: string;
  public showUploadSuccess = false;
  public failedRows = [];
  public showFileErrors = false;
  private config: any;
  public bulkBookingConfigObj: any;
  public fileTotalSize: number;
  public percentDone = 0;
  public showProgressBar = false;
  public onGoingFileUpload = false;
  showFilePassed = false;
  showErrorDialog = false;
  fileUploadErrorMessage = "";
  fileImg: string;
  uplaodImg = "assets/images/upload.svg";
  message = "Drag & drop the file you want to upload";
  browseLabel = "Browse";
  @ViewChild('progressElement', { static: true }) inputVar: ElementRef;
  passedRows = [];
  errorMessage = "";
  showFileNameError = false;
  imgURL: string;
  templateData: DropdownItem[] = [];
  selectedTemplate: DropdownItem = { value: '', label: '' };
  isDisabled = true;
  showOnUploadAttempt = false;
  uplaodBtnLabel = "Begin Upload";
  isSuccess: "SUCCESS" | "FAILED";
  constructor(private bulkCreateService: BulkCreateService, private commonBillingService: CommonBillingService,
              private commonService: CommonService,
              private router: Router) {
                this.imgURL = '../assets';
  }

  ngOnInit() {
    // this.showFileUploadModal =  true;
    // this.fileToUpload = {};
    this.fileImg =  this.imgURL + "/images/file.svg";
    this.getConfigs();
  }

  getConfigs() {
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Bulk Booking Page');
      const downloadTemplateConfig = this.commonService.getConfigForElementKey(this.config, 'Download Template');
      this.bulkBookingConfigObj = {};
      for (const configData of downloadTemplateConfig.elementConfigList) {
        this.bulkBookingConfigObj[configData.elementKey] = configData.config;
      }
      this.templateData = [
        { label: 'Single Pickup Drop Template.xls', value: "single" },
        {label: 'Mulptiple Pickup Drop Template.xls', value: 'multi'}
      ];
      // { label: this.bulkBookingConfigObj.MultipleBookingsSinglePickUpDrop.displayName + 'Single Pickup Drop Template.xls.xls.xls', value: "single" },
      // {label:  this.bulkBookingConfigObj.TeamOuting.displayName + 'Mulptiple Pickup Drop Template.xls.xls', value: 'multi'}

    });
  }

 /*  handleDownloadTemplateXLS() {
    this.isLoading = true;
    this.bulkCreateService.downloadBulkBookingTemplate('single').subscribe((response) => {
      this.commonBillingService.downloadBlob(response);
      this.isLoading = false;
    },
    (error) => {
      this.isLoading = false;
      this.errorMessage = error.status === 404 ?  "Resource not available" : "Some error occurred";
      this.showErrorDialog = true;
    }
    );
  }

  handleMultiSDownloadTemplateXLS() {
    this.isLoading = true;
    this.bulkCreateService.downloadBulkBookingTemplate('multi').subscribe((response) => {
      this.commonBillingService.downloadBlob(response);
      this.isLoading = false;
    },
    (error) => {
      this.isLoading = false;
      this.errorMessage = error.status === 404 ?  "Resource not available" : "Some error occurred";
      this.showErrorDialog = true;
    }
    );
  } */

  downloadTemplate(event) {
    this.isLoading = true;
    this.selectedTemplate = event;
    if (event.value === 'single') {
      this.bulkCreateService.downloadBulkBookingTemplate('single').subscribe((response) => {
        this.commonBillingService.downloadBlob(response);
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = error.status === 404 ?  "Resource not available" : "Some error occurred";
        this.showErrorDialog = true;
      }
      );
    } else if (event.value === 'multi') {
      this.bulkCreateService.downloadBulkBookingTemplate('multi').subscribe((response) => {
        this.commonBillingService.downloadBlob(response);
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = error.status === 404 ?  "Resource not available" : "Some error occurred";
        this.showErrorDialog = true;
      }
      );
    }
  }

  fileSelected(file: any) {
    if (file) {
      this.isDisabled = false;
      this.fileToUpload = file;
      this.percentDone = 0;
      // this.showFileUploadModal =  true;
      this.uplaodImg = 'assets/images/upload-ready.svg';
      this.message = "File is ready to be uploaded";
      this.fileName = this.fileToUpload.name;
      this.browseLabel = "Wrong File? <u class=\"file-info-message\">Choose Again</u>";
      this.showProgressBar = false;
      this.failedRows = [];
      this.passedRows = [];

      // this.submitUploadReport();
    }
  }

  beginDownload(label: string) {
    if (label === 'Begin Upload') {
      this.submitUploadReport();
    } else if (label === 'Retry') {
      /**
       * reset img
       * reset msg
       * reset filename
       * reset file input & button
       * reset button
       */
       this.uplaodImg = 'assets/images/upload.svg';
       this.message = "Drag & drop the file you want to upload";
       this.fileName = "";
       this.uplaodBtnLabel = "Begin Upload";
       this.browseLabel = "Browse";
       this.showFileUploadModal = false;
       this.showOnUploadAttempt = false;
    }
  }

  submitUploadReport() {
    const searchQuery = {
      uploadFile: this.fileToUpload
    };
    this.fileTotalSize = this.fileToUpload.size;
    this.showFileUploadModal =  true;
    this.showUploadModal =  true;
    // this.showProgressBar = true;
    // this.onGoingFileUpload = true;
    this.failedRows = [];
    this.bulkCreateService.uploadBulkBooking(searchQuery).subscribe((event: any) => {
      // event progress
      if (event.type === HttpEventType.DownloadProgress) {
        if (this.fileTotalSize) {
          this.percentDone = Math.round(100 * event.loaded / this.fileTotalSize);
          this.inputVar.nativeElement.style.width = this.percentDone + '%';
        }
      }

      // event complete
      if (event.type === HttpEventType.Response) {
        if (!event.body.validFile) {
          // this.showFileNameError = true;
          this.fileUploadErrorMessage = "Uploaded sheet name is incorrect";
          this.onGoingFileUpload = false;
          this.showProgressBar = false;
          this.uplaodImg = 'assets/images/upload-error.svg';
          this.message = "Uploaded sheet name is incorrect";
          this.uplaodBtnLabel = "Retry";
          this.showUploadModal =  false;
          this.fileToUpload = null;
        } else {
          this.percentDone = 100;
          this.onGoingFileUpload = false;
          this.inputVar.nativeElement.style.width = this.percentDone + '%';
          if (event.body.spotBookingList && event.body.spotBookingList.length) {
            this.passedRows = event.body.spotBookingList;
          }
          if (event.body.errorDTO && event.body.errorDTO.length) {
            this.failedRows = event.body.errorDTO;
            this.handleDismissUploadFileModal();
          } else {
            this.showUploadSuccess = false;
            this.showOnUploadAttempt = true;
            this.uplaodImg = 'assets/images/upload-success.svg';
            this.message = "File successfully uploaded";
            this.browseLabel = "<span class=\"browse see-detail\">See details</span>";
            this.uplaodBtnLabel = "Retry";
            this.showUploadModal =  false;
            this.isSuccess = 'SUCCESS';
            this.fileToUpload = null;
            // this.showFileUploadModal = false;
         }
        }
      }
    }, (data) => {
    /*   this.failedRows = [
        {rowNo: '101', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '102', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '103', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '104', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '105', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '106', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '107', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '108', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '109', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
        {rowNo: '110', columnName: 'Cab Type', errorMessage: 'Incorrect cab type provided (expected mercedes c class)'},
      ] */
      this.showProgressBar = false;
      // this.showFileUploadModal = false;
      this.showOnUploadAttempt = true;
      this.showUploadModal = false;
      this.onGoingFileUpload = false;
      this.uploadFileError = data.error.message || 'Upload failed!';
      this.uplaodImg = 'assets/images/upload-error.svg';
      this.message = data.error.message || 'Upload failed!';
      this.browseLabel = "<span class=\"file-info-message file-error\">" + this.failedRows.length + " Error(s) found </span></spa><span class=\"file-info-message\"><u class=\"file-info-message\">See error details</u></span>";
      this.uplaodBtnLabel = "Retry";
      this.isSuccess = 'FAILED';
    });
  }

  handlePassedBooking() {
    if (this.passedRows.length) {
      this.showFilePassed = true;
    }
  }

  handleShowErrorMessage() {
    if (this.failedRows.length) {
      this.showFileErrors = true;
    }
  }
  toggleToast() {
    this.showUploadSuccess = false;
  }

  handleDismissUploadFileModal() {
    // this.showFileUploadModal =  false;
    this.showOnUploadAttempt = true;
    this.fileToUpload = null;
    this.uploadFileError = '';
    this.showUploadModal = false;
    this.uplaodImg = 'assets/images/upload-error.svg';
    this.message = 'There are a few conflicts in your file';
    this.browseLabel = "<span class=\"file-info-message file-error\">" + this.failedRows.length + " Error(s) found </span></spa><span class=\"file-info-message\"><u class=\"file-info-message\">See error details</u></span>";
    this.uplaodBtnLabel = "Retry";
    this.isSuccess = 'FAILED';
  }

  dismissError() {
    this.showFileErrors = false;
    this.showFilePassed = false;
    this.showErrorDialog = false;
    this.showFileNameError = false;
    this.errorMessage = "";
    this.fileUploadErrorMessage = "";
  }

  openModalCallback(event) {
    if (event === 'SUCCESS') {
      this.handlePassedBooking();
    } else if (event === 'FAILED') {
      this.handleShowErrorMessage();
    }
  }

  cancelBooking() {
    this.router.navigate([`/bookings`]);
  }
}
